import { NextPage } from 'next';
import { AcceptOfferBackwardsCompatibilityInterceptor } from './AcceptOfferBackwardsCompatibilityInterceptor';

interface AcceptSellBackwardsCompatibilityInterceptorProps {
  searchParams: Promise<Record<string, string | undefined>>;
}

const AcceptSellBackwardsCompatibilityInterceptor: NextPage<
  AcceptSellBackwardsCompatibilityInterceptorProps
> = async ({ searchParams }) => {
  const { tradeOfferID } = await searchParams;

  return (
    <AcceptOfferBackwardsCompatibilityInterceptor
      operation="sell"
      tradeOfferID={tradeOfferID}
    />
  );
};

export { AcceptSellBackwardsCompatibilityInterceptor };
